import { RUNSCRIPTS__LATEST__REQUESTED__SUCCEEDED } from "../constants/actionTypes";

import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function runscripts(state = INITIAL_STATE, action) {
    switch (action.type) {

        case RUNSCRIPTS__LATEST__REQUESTED__SUCCEEDED: {
            const { runscripts } = action.payload;

            return _.mapKeys(runscripts.entities, id);
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/runscriptsReducer.js
 **/